import { render, staticRenderFns } from "./DiscountUsers.vue?vue&type=template&id=3f5fbccf&"
import script from "./DiscountUsers.vue?vue&type=script&lang=js&"
export * from "./DiscountUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports